import React, { useEffect, useRef, useState } from "react"
// import { gtag } from "ga-gtag"
import NewCarousel from "../carousel/NewCarousel"
import { useAppContext } from "../../context/appContext"
import * as styles from "./index.module.css"
import { onContactUsBtnClick } from "../../commonFunctions/commonFunctions"
import { Link } from "gatsby"

export const ConnectWithUsBtns = ({
  // initialTitle,
  showBothButtons,
  // setShowChatWindow,
  setShowBothButtons,
  // onContactUsBtnClick,
}) => {
  const { setShowChatWindow, setShowContactFormWindow } = useAppContext()
  const connectBtnsContainerRef = useRef(null)

  const handleClickOutside = event => {
    if (
      connectBtnsContainerRef.current &&
      !connectBtnsContainerRef.current.contains(event.target)
    ) {
      setShowBothButtons(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div className="connect-btns" ref={connectBtnsContainerRef}>
      <div className="button_container">
        <button
          className={`${
            showBothButtons ? "ai-rep-btn slide-out-2" : "button-cl connectBtn"
          }`}
          // onClick={() => onContactUsBtnClick("Im_Interested_cta")}
          onClick={() => {
            if (showBothButtons) {
              setShowChatWindow(true)
              setShowBothButtons(false)
            } else {
              setShowBothButtons(true)
            }
          }}
          // style={{ width: "100%", zIndex: "2" }}
        >
          {!showBothButtons ? "Let’s Connect" : "Try our AI rep"}
        </button>
        {/* {showBothButtons && ( */}
      </div>
      <div
        className={`${
          !showBothButtons ? "hidden" : "slide-in button_container"
        }`}
      >
        <button
          className={`${
            showBothButtons ? "slide-in" : "slide-out"
          } contact-us-btn`}
          onClick={() => {
            onContactUsBtnClick("Im_Interested_cta", setShowContactFormWindow)
            setShowBothButtons(false)
          }}
        >
          Schedule Consultation
        </button>
        {/* )} */}
      </div>
    </div>
  )
}

const Home = ({
  carouselData,
  isGovernmentsection,
  isHealthcaresection,
  sectionData,
}) => {
  const { setShowChatWindow } = useAppContext()
  const [isMobile, setIsMobile] = useState(false)
  const [showBothButtons, setShowBothButtons] = useState(false)

  useEffect(() => {
    resizeCallback()
    function resizeCallback() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      if (width < 550) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }
    window.addEventListener("resize", resizeCallback)
    return () => window.removeEventListener("resize", resizeCallback)
  }, [])

  // const onContactUsBtnClick = ctaTitle => {
  //   // document.getElementById("heartElement")?.click()
  //   setShowContactFormWindow(true)

  //   gtag("event", ctaTitle, {
  //     event_category: "contact-us",
  //     event_label: "Contact Form",
  //   })
  // }

  return (
    <>
      <div
        className={(styles.textCenter, styles.wrapperHome)}
        id="success-stories-section"
      >
        <div className={styles.contentWrapper}>
          {!isGovernmentsection && !isHealthcaresection ? (
            <h1 className={`${styles.mainText} homepage-maintitle`}>
              Take Your{" "}
              <span className={styles.textStyle}>GenAI to Production</span> and
              Cut Costs within Weeks
            </h1>
          ) : (
            <h1 className={`${styles.mainText} homepage-maintitle`}>
              We build{" "}
              <span className={styles.textStyle}>custom AI solutions</span> for
              {isGovernmentsection
                ? " government customers"
                : isHealthcaresection
                ? " healthcare enterprises"
                : " enterprises"}
            </h1>
          )}
          {/* {isMobile ? (
            <div className={`${styles.subText} homepage-subtitle`}>
              <div>
                Your{" "}
                <u
                // className={styles.ourPropositionsHover}
                // onClick={() => setIsHover(true)}
                >
                  one-stop
                </u>{" "}
                shop engineering firm,
              </div>
              <div>
                {" "}
                from ideation to{" "}
                <u
                // className={styles.ourPropositionsHover}
                // onClick={() => setIsHover(true)}
                >
                  ROI
                </u>{" "}
                realization!
              </div>
            </div>
          ) : (
            <div className={`${styles.subText} homepage-subtitle`}>
              Your{" "}
              <u
              // className={styles.ourPropositionsHover}
              // onMouseEnter={() => setIsHover(prev => !prev)}
              // onMouseLeave={() => setIsHover(false)}
              >
                one-stop
              </u>{" "}
              shop engineering firm, from ideation to{" "}
              <u
              // className={styles.ourPropositionsHover}
              // onMouseEnter={() => setIsHover(true)}
              // onMouseLeave={() => setIsHover(false)}
              >
                ROI
              </u>{" "}
              realization!
            </div>
          )} */}
        </div>

        <div></div>

        {/* New Carousel using Swiper.js */}
        <NewCarousel data={carouselData} />

        <div
          className={`${styles.ctaContainer} ${
            isGovernmentsection
              ? "Government-cta-container"
              : "homepage-cta-container"
          }`}
        >
          <p className={styles.ctaTitle}>
            Ready to take your AI to Production & Beyond?
          </p>
          {/* <ConnectWithUsBtns
            // initialTitle={"Let's Connect"}
            showBothButtons={showBothButtons}
            setShowBothButtons={setShowBothButtons}
            // setShowChatWindow={setShowChatWindow}
            // onContactUsBtnClick={onContactUsBtnClick}
          /> */}
          <div className="new-buttons-wrapper">
            <div className={`new-button-container`}>
              <Link to={"/book-demo"}>
                <button className={"old-design new-blue standout"}>
                  {/* {cardData?.cta?.cta_name} */}
                  Schedule a Consultation
                </button>
              </Link>
            </div>
          </div>
        </div>

        <a
          className={`${styles.recentNewsBar} recent-news-bar`}
          // onClick={handleNavigate}
          href="https://www.techolution.com/new-chief-revenue-officer-ash-kamdar/"
          target="_blank"
        >
          {isMobile ? (
            <span className={styles.scrollingText}>
              <span style={{ fontWeight: "bold" }}>Latest News:</span> Ash
              Kamdar joins Techolution as Chief Revenue Officer!{" "}
              <u>Click here</u> to learn more
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              <span style={{ fontWeight: "bold" }}>Latest News:</span> Ash
              Kamdar joins Techolution as Chief Revenue Officer!{" "}
              <u>Click here</u> to learn more
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          ) : (
            <span className={styles.scrollingText}>
              <span style={{ fontWeight: "bold" }}>Latest News:</span> Ash
              Kamdar joins Techolution as Chief Revenue Officer!{" "}
              <u>Click here</u> to learn more
            </span>
          )}
        </a>
      </div>
    </>
  )
}

export default Home
